// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PartnerScoreAssetConfig from "../../assets/PartnerScoreAssetConfig.bs.js";

function LockedCardInfoV2(Props) {
  var locked_msg = Props.locked_msg;
  return React.createElement("div", {
              className: "locked-info-card-v2"
            }, React.createElement("img", {
                  className: "locked-info-card__icon",
                  src: PartnerScoreAssetConfig.lock_icon
                }), React.createElement("div", {
                  className: "locked-info-card__content"
                }, locked_msg));
}

var make = LockedCardInfoV2;

export {
  make ,
  
}
/* react Not a pure module */
